import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import { epinSpotlight } from '@/mocks/epin';

export default function SolutionSpotlight() {
  const d = epinSpotlight;

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* 页面小标题 */}
        <Reveal>
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-semibold tracking-wide whitespace-nowrap">
              <i className="ri-apps-2-line"></i>
              解决方案 · 重点专题
            </span>
            <h1 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
              按业务目标组合产品与技术，落地可用的数字方案
            </h1>
            <div className="mt-3 text-xs md:text-sm font-medium tracking-[0.32em] uppercase text-foreground-400">
              Solutions
            </div>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              我们围绕县域商业、乡村产业与食品安全，把可复用的能力沉淀成标准方案，帮助企业快速落地。以下是我们近期的重点专题之一。
            </p>
          </div>
        </Reveal>

        {/* ePin食安码 入口卡片 */}
        <Reveal delay={100}>
          <div className="mt-10 md:mt-12 grid grid-cols-1 lg:grid-cols-[1fr_minmax(0,460px)] gap-6 lg:gap-10 items-stretch rounded-lg border border-background-200 bg-background-100 overflow-hidden">
            <div className="p-6 md:p-9 flex flex-col">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-semibold tracking-wide whitespace-nowrap w-fit">
                <i className="ri-qr-code-line"></i>
                {d.eyebrow}
              </span>
              <h2 className="mt-4 font-heading font-bold text-xl md:text-2xl text-foreground-950 leading-snug">
                {d.title}
              </h2>
              <p className="mt-3 text-sm text-foreground-700 leading-relaxed">
                {d.desc}
              </p>

              <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
                {d.points.map((p) => (
                  <li key={p} className="flex items-start gap-2.5">
                    <span className="w-5 h-5 shrink-0 mt-0.5 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                      <i className="ri-check-line text-xs"></i>
                    </span>
                    <span className="text-sm text-foreground-700 leading-relaxed">{p}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-8 pt-6 border-t border-background-200 flex flex-wrap gap-3">
                <Link
                  to={d.href}
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600"
                >
                  {d.primaryCta}
                  <i className="ri-arrow-right-line text-base"></i>
                </Link>
                <Link
                  to={d.secondaryHref}
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-50 border border-background-300 text-foreground-700 text-sm whitespace-nowrap cursor-pointer transition-colors hover:border-accent-400 hover:text-accent-800"
                >
                  <i className="ri-shield-check-line"></i>
                  {d.secondaryCta}
                </Link>
              </div>
            </div>

            <div className="relative min-h-[240px] lg:min-h-full overflow-hidden">
              <img
                src={d.imageUrl}
                alt="ePin食安码 一物一码全链路溯源"
                title="华辉数智 ePin食安码"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}